"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFacilityState = parseFacilityState;
const states_1 = require("encamp-shared/dist/constants/states");
const PROVINCE_SET = new Set(states_1.PROVINCES);
/**
 * Callers hand us `Facility.state` exactly as they hold it. Null is a facility
 * with no recorded state, and a Canadian province or territory has no US state
 * law; both answer under federal law. Anything else that isn't a two-letter
 * uppercase abbreviation throws rather than quietly falling back, because a
 * silent fallback would mask the data bug.
 *
 * Shared by the jurisdiction registry and the episodic module so the two can
 * never disagree about which state is speaking.
 */
function parseFacilityState(state) {
    if (state === null || PROVINCE_SET.has(state)) {
        return null;
    }
    if (!(0, states_1.isStateAbbreviation)(state)) {
        throw new Error(`Unrecognized facility state ${JSON.stringify(state)} — expected a two-letter uppercase ` +
            `abbreviation or null.`);
    }
    return state;
}
//# sourceMappingURL=facilityState.js.map